module.exports = __webpack_public_path__ + "static/bearvelourmain-85dd0009064232382a5e92454bc3fea5.png";